import { Group } from '@era/security-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export function selectGroupIdFromParent(group: Group) {
  return `${group.parentId}-${group.id}`;
}

export function createMemberGroupFromParent(group: Group, parentGroup: Group) {
  const memberGroup: Group = {
    id: group.id,
    parentId: parentGroup.id,
    displayName: group.displayName,
  };

  return memberGroup;
}

export const adapter: EntityAdapter<Group> = createEntityAdapter<Group>({
  selectId: selectGroupIdFromParent,
});

export type MemberGroupState = EntityState<Group>;

export const initialstate: MemberGroupState = adapter.getInitialState();
